import { render, staticRenderFns } from "./Social.vue?vue&type=template&id=78cce17f"
import script from "./Social.vue?vue&type=script&lang=js"
export * from "./Social.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78cce17f')) {
      api.createRecord('78cce17f', component.options)
    } else {
      api.reload('78cce17f', component.options)
    }
    module.hot.accept("./Social.vue?vue&type=template&id=78cce17f", function () {
      api.rerender('78cce17f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/News/Social.vue"
export default component.exports